import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import { fetchTaskPlan } from "./api";
import type { PendingPlanResponse } from "./api";

// Pending-план эпика для TaskDetailPage: org-scoped запрос (см.
// `src/query/scope.ts`), грузится только в awaiting_plan_approval
// (conditional через `enabled`).
//
// `null` — у задачи нет pending-плана (штатно).
//
// Ключ ["task-plan", taskId] инвалидируют approve/reject-мутации и
// обработчик уведомлений страницы.
export function useTaskPlan(
  taskId: string,
  options?: { readonly enabled?: boolean },
): UseQueryResult<PendingPlanResponse | null, Error> {
  return useOrgScopedQuery<PendingPlanResponse | null>({
    key: ["task-plan", taskId],
    queryFn: () => fetchTaskPlan(taskId),
    enabled: options?.enabled ?? true,
    retry: false,
  });
}
